<div [ngClass]="filterLabel ? 'filter-label' : 'form-label'">Contact</div>
<ng-select
  (click)="$event.stopPropagation()"
  (keydown)="changeSelection()"
  [(ngModel)]="_selectedContact"
  (ngModelChange)="changeSelection()"
  [items]="(contacts$ | async) || []"
  [typeahead]="searchInput$"
  [virtualScroll]="true"
  [loading]="loadingContacts()"
  (scrollToEnd)="onScrollToEnd()"
  (scroll)="onScroll($event)"
  bindLabel="option"
  bindValue="value"
  placeholder="Select a contact"
  notFoundText="No contact found.">
</ng-select>
